import React from 'react';
import { useTranslation } from 'react-i18next';
import * as R from 'ramda';
import TitleContainer from './TitleContainer';
import { isUniquenessPortal, isProdMainnet } from '../util';
import Button, { ButtonStyle } from '../Components/Button';
import ButtonContainer from '../Components/ButtonContainer';

interface StatusPanelContentProps {
  status: string;
  handleButtonClick: () => void;
  handleLearnMore: () => void;
}

export default function StatusPanelContent({
  status,
  handleButtonClick,
  handleLearnMore,
}: StatusPanelContentProps): JSX.Element {
  const { t } = useTranslation();
  const title = t('screens.tokenStatus.title', { context: status });
  const description = t('screens.tokenStatus.description', { context: status });

  return (
    <>
      <>
        {!R.isEmpty(title) && (
          <TitleContainer marginBottomClass="mb-2">
            <h1 className="mb-2">{title}</h1>
          </TitleContainer>
        )}
      </>

      <>{!R.isEmpty(description) && <p className="mb-5">{description}</p>}</>

      <div className="wallet-connection-image">
        <img src="PassImage.png" alt="Civic Pass Logo" />
      </div>

      {!isProdMainnet && (
        <div className="mx-3 mb-1 mt-4 flex transform flex-row items-center justify-center rounded-lg border border-borderPrimary p-4 shadow-lg">
          <div className="p-1 items-center lg:rounded-full flex lg:inline-flex" role="alert">
            <svg width="24" height="24" fill="#FF6B4E" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 9h-2V7h2m0 10h-2v-6h2m-1-9A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z" />
            </svg>
            <span className="w-full pl-3 whitespace-pre-wrap textDetail">
              {t('screens.tokenStatus.devnetMessage')}
              <a
                target="_blank"
                title="solfaucet.com"
                href="https://solfaucet.com/"
                className="underline textLink"
                rel="noreferrer"
              >
                {t('screens.tokenStatus.devnetMessageLink')}
              </a>
            </span>
          </div>
        </div>
      )}

      <p className="mt-4 mb-5">{isUniquenessPortal() ? t('screens.tokenStatus.uniquenessBlurb') : ''}</p>

      <p className="mb-5">
        <button type="button" className={`status-button ${status}`} onClick={handleButtonClick}>
          <span className={`dot ${status} mr-2`} />
          <span>{t('screens.tokenStatus.buttonLabel', { context: status })}</span>
        </button>
      </p>

      <ButtonContainer>
        <Button style={ButtonStyle.INVERTED} disabled={false} extraClasses="mb-2" onClick={handleLearnMore}>
          <span>{t('screens.tokenStatus.supportLink', { context: status })}</span>
        </Button>
      </ButtonContainer>
    </>
  );
}
